import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-groups',
  templateUrl: './input-groups.component.html',
})
export class InputGroupsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
